import { Box, Text } from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'
import { spacingPx } from '@moonpig/launchpad-theme'
import { styled, keyframes } from '@moonpig/launchpad-utils'

const bounce = keyframes`
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 0.4;
  }

  40% {
    transform: translateY(-4px);
    opacity: 1;
  }
`

export const ThinkingMessageStyledBox = styled(Box)`
  display: inline-flex;
  align-items: center;
  width: fit-content;

  ${s({
    bgcolor: 'colorBackground02',
    gap: 4,
    padding: 5,
    marginRight: 11,
    marginLeft: 0,
    marginBottom: 8,
    borderRadius: 2,
  })}

  border-bottom-left-radius: 0;
`

export const StyledDotsRow = styled(Box)`
  display: inline-flex;
  align-items: center;
  padding-top: 6px;

  ${s({
    gap: 2,
    color: 'colorTextHeadline',
  })}
`

export const StyledDot = styled.span<{ $delay: string }>`
  display: inline-block;
  width: ${spacingPx(3)};
  height: ${spacingPx(3)};
  border-radius: 50%;
   ${s({
     bgcolor: 'colorPrimary02',
   })}
  animation: ${bounce} 1200ms ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay};
`

export const StyledLabel = styled(Text)`
  ${s({
    typography: 'typeBodyText',
    color: 'colorTextHeadline',
    fontWeight: '300',
    marginBottom: 0,
  })}
`
